import Vue from 'vue';
import 'chartist/dist/chartist.min.css';

// tslint:disable-next-line:no-var-requires
Vue.use(require('vue-chartist'));
